// Components/CartWrapper.js
import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Cart from "./Cart";

const stripePromise = loadStripe(
  "pk_live_51SJyRNGlKX6C1N1BsaTyxjT7WDnOJCDoanb4z6rkfGVjXSF2WvbS8Aia16Pu2tyw7enE5XWnXNGnapBasSvc2Jyh00OKVpoBT5"
);

const CartWrapper = ({ isOpen, onClose }) => (
  <Elements stripe={stripePromise}>
    <Cart isOpen={isOpen} onClose={onClose} />
  </Elements>
);

export default CartWrapper;
